function newsSlider() {
  var newsSlider = $(".js-news-slider");
  newsSlider.slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    focusOnSelect: true,
    fade: true,
  });
}


export default newsSlider;